function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.95 8.96" {...props}><path d="M5.15.91l-3 2.9h7.2a.65.65 0 0 1 .6.6v.1a.65.65 0 0 1-.6.6h-7.2l3 2.9a.57.57 0 0 1-.8.8l-4.2-4a.38.38 0 0 1 0-.6l4.2-4a.62.62 0 0 1 .8-.1.52.52 0 0 1 0 .8z" fill="currentColor" fillRule="evenodd" /></svg>;
});